@if (visualization === 'treemap') {
  <div class="treemap" role="group" aria-label="Products treemap">
    @for (tile of treemapTiles; track tile.id) {
      <div class="treemap-tile" role="img" tabindex="0"
        [attr.aria-label]="tile.label + ': ' + formatValue(tile.value) + ' ' + tile.unit"
        [title]="tile.label + ': ' + formatValue(tile.value) + ' ' + tile.unit"
        [style.left.%]="tile.x" [style.top.%]="tile.y" [style.width.%]="tile.width" [style.height.%]="tile.height"
        [style.background]="color(tile.id)">
        <span class="treemap-label">{{ tile.label }}</span>
        <strong class="treemap-value">{{ formatValue(tile.value) }} {{ tile.unit }}</strong>
      </div>
    }
    @if (!treemapTiles.length) { <div class="text-secondary text-center p-3">No positive values to display.</div> }
  </div>
} @else if (visualization === 'donut' || visualization === 'pie') {
  <div class="donut-layout circular-layout">
    <div class="donut" [class.pie]="visualization === 'pie'" [style.background]="donutBackground" role="img" [attr.aria-label]="visualization + ' report chart'">
        @for (label of pieLabels; track label.label) {
          <span class="pie-label" [style.left.%]="label.x" [style.top.%]="label.y" [title]="label.label">{{label.text}}</span>
        }
    </div>
    <div class="report-chart-legend">
      @for (slice of donutSlices; track slice.label; let index = $index) {
        <div class="report-chart-legend-item">
          <span class="report-chart-legend-dot" [style.background]="slice.color"></span>
          <span class="report-chart-legend-label" [title]="slice.label">{{ slice.label }}</span>
          <strong>{{ formatValue(slice.value) }}</strong>
        </div>
      }
    </div>
  </div>
} @else {
  <div class="chart-shell">
    <svg
      class="chart"
      [attr.viewBox]="'0 0 ' + chartWidth + ' ' + chartHeight"
      role="img"
      [attr.aria-label]="visualization + ' report chart'"
      preserveAspectRatio="none"
    >
      <line class="grid-line" x1="0" [attr.x2]="chartWidth" y1="192" y2="192"></line>
      <line class="grid-line" x1="0" [attr.x2]="chartWidth" y1="102" y2="102"></line>
      @if (visualization === 'bar') {
        @for (bar of bars; track bar.category + bar.series) {
          <rect
            class="bar"
            rx="3"
            [attr.x]="bar.x"
            [attr.y]="bar.y"
            [attr.width]="bar.width"
            [attr.height]="bar.height"
            [attr.fill]="bar.color"
          ><title>{{ bar.category }} · {{ bar.series }}: {{ formatValue(bar.value) }}</title></rect>
        }
      } @else {
        @for (item of linePaths; track item.name) {
          @if (visualization === 'area') {
            <path class="area" [attr.d]="item.areaPath" [attr.fill]="item.color"></path>
          }
          <path class="line" [attr.d]="item.path" [attr.stroke]="item.color"></path>
        }
      }
    </svg>
    <div class="axis-labels">
      @for (category of categories; track category) {
        <span [title]="category">{{ category }}</span>
      }
    </div>
  </div>
  @if (series.length > 1) {
    <div class="report-chart-legend compact">
      @for (item of series; track item.name; let index = $index) {
        <div class="report-chart-legend-item">
          <span class="report-chart-legend-dot" [style.background]="color(index)"></span>
          <span class="report-chart-legend-label">{{ item.name }}</span>
        </div>
      }
    </div>
  }
}
